export const IconArrowLeft = ({ width = 18 }) => {
  return (
    <svg width={width} height={width} viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.60254 9.89746L1 5.29492L5.60254 0.692383" stroke="#2F3234" strokeWidth="1.33333" />
    </svg>
  );
};
